package ch.wsl.typings.jspdfAutotable.mod

import ch.wsl.typings.jspdfAutotable.anon.PartialStyles
import ch.wsl.typings.jspdfAutotable.jspdfAutotableBooleans.`false`
import org.scalablytyped.runtime.StringDictionary
import org.scalajs.dom.HTMLTableElement
import org.scalablytyped.runtime.StObject
import scala.scalajs.js
import scala.scalajs.js.`|`
import scala.scalajs.js.annotation.{JSGlobalScope, JSGlobal, JSImport, JSName, JSBracketAccess}

@js.native
trait UserOptions extends StObject {
  
  var alternateRowStyles: js.UndefOr[PartialStyles] = js.native
  
  var body: js.UndefOr[js.Array[RowInput]] = js.native
  
  var bodyStyles: js.UndefOr[PartialStyles] = js.native
  
  var columnStyles: js.UndefOr[StringDictionary[PartialStyles]] = js.native
  
  var columns: js.UndefOr[js.Array[ColumnInput]] = js.native
  
  var didDrawCell: js.UndefOr[CellHook] = js.native
  
  var didDrawPage: js.UndefOr[PageHook] = js.native
  
  var didParseCell: js.UndefOr[CellHook] = js.native
  
  var foot: js.UndefOr[js.Array[RowInput]] = js.native
  
  var footStyles: js.UndefOr[PartialStyles] = js.native
  
  var head: js.UndefOr[js.Array[RowInput]] = js.native
  
  var headStyles: js.UndefOr[PartialStyles] = js.native
  
  var horizontalPageBreak: js.UndefOr[Boolean] = js.native
  
  var horizontalPageBreakRepeat: js.UndefOr[String | Double] = js.native
  
  var html: js.UndefOr[String | HTMLTableElement] = js.native
  
  var includeHiddenHtml: js.UndefOr[Boolean] = js.native
  
  var margin: js.UndefOr[MarginPaddingInput] = js.native
  
  var pageBreak: js.UndefOr[PageBreakType] = js.native
  
  var rowPageBreak: js.UndefOr[RowPageBreakType] = js.native
  
  var showFoot: js.UndefOr[ShowFootType] = js.native
  
  var showHead: js.UndefOr[ShowHeadType] = js.native
  
  var startY: js.UndefOr[Double | `false`] = js.native
  
  var styles: js.UndefOr[PartialStyles] = js.native
  
  var tableId: js.UndefOr[String | Double] = js.native
  
  var tableLineColor: js.UndefOr[Color] = js.native
  
  var tableLineWidth: js.UndefOr[Double] = js.native
  
  var tableWidth: js.UndefOr[TableWidthType] = js.native
  
  var theme: js.UndefOr[ThemeType] = js.native
  
  var useCss: js.UndefOr[Boolean] = js.native
  
  var willDrawCell: js.UndefOr[CellHook] = js.native
}
object UserOptions {
  
  @scala.inline
  def apply(): UserOptions = {
    val __obj = js.Dynamic.literal()
    __obj.asInstanceOf[UserOptions]
  }
  
  @scala.inline
  implicit class MutableBuilder[Self <: UserOptions] (val x: Self) extends AnyVal {
    
    @scala.inline
    def setAlternateRowStyles(value: PartialStyles): Self = StObject.set(x, "alternateRowStyles", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setAlternateRowStylesUndefined: Self = StObject.set(x, "alternateRowStyles", js.undefined)
    
    @scala.inline
    def setBody(value: js.Array[RowInput]): Self = StObject.set(x, "body", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setBodyStyles(value: PartialStyles): Self = StObject.set(x, "bodyStyles", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setBodyStylesUndefined: Self = StObject.set(x, "bodyStyles", js.undefined)
    
    @scala.inline
    def setBodyUndefined: Self = StObject.set(x, "body", js.undefined)
    
    @scala.inline
    def setBodyVarargs(value: RowInput*): Self = StObject.set(x, "body", js.Array(value :_*))
    
    @scala.inline
    def setColumnStyles(value: StringDictionary[PartialStyles]): Self = StObject.set(x, "columnStyles", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setColumnStylesUndefined: Self = StObject.set(x, "columnStyles", js.undefined)
    
    @scala.inline
    def setColumns(value: js.Array[ColumnInput]): Self = StObject.set(x, "columns", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setColumnsUndefined: Self = StObject.set(x, "columns", js.undefined)
    
    @scala.inline
    def setColumnsVarargs(value: ColumnInput*): Self = StObject.set(x, "columns", js.Array(value :_*))
    
    @scala.inline
    def setDidDrawCell(value: /* data */ CellHookData => Unit | Boolean): Self = StObject.set(x, "didDrawCell", js.Any.fromFunction1(value))
    
    @scala.inline
    def setDidDrawCellUndefined: Self = StObject.set(x, "didDrawCell", js.undefined)
    
    @scala.inline
    def setDidDrawPage(value: /* data */ HookData => Unit | Boolean): Self = StObject.set(x, "didDrawPage", js.Any.fromFunction1(value))
    
    @scala.inline
    def setDidDrawPageUndefined: Self = StObject.set(x, "didDrawPage", js.undefined)
    
    @scala.inline
    def setDidParseCell(value: /* data */ CellHookData => Unit | Boolean): Self = StObject.set(x, "didParseCell", js.Any.fromFunction1(value))
    
    @scala.inline
    def setDidParseCellUndefined: Self = StObject.set(x, "didParseCell", js.undefined)
    
    @scala.inline
    def setFoot(value: js.Array[RowInput]): Self = StObject.set(x, "foot", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setFootStyles(value: PartialStyles): Self = StObject.set(x, "footStyles", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setFootStylesUndefined: Self = StObject.set(x, "footStyles", js.undefined)
    
    @scala.inline
    def setFootUndefined: Self = StObject.set(x, "foot", js.undefined)
    
    @scala.inline
    def setFootVarargs(value: RowInput*): Self = StObject.set(x, "foot", js.Array(value :_*))
    
    @scala.inline
    def setHead(value: js.Array[RowInput]): Self = StObject.set(x, "head", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setHeadStyles(value: PartialStyles): Self = StObject.set(x, "headStyles", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setHeadStylesUndefined: Self = StObject.set(x, "headStyles", js.undefined)
    
    @scala.inline
    def setHeadUndefined: Self = StObject.set(x, "head", js.undefined)
    
    @scala.inline
    def setHeadVarargs(value: RowInput*): Self = StObject.set(x, "head", js.Array(value :_*))
    
    @scala.inline
    def setHorizontalPageBreak(value: Boolean): Self = StObject.set(x, "horizontalPageBreak", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setHorizontalPageBreakRepeat(value: String | Double): Self = StObject.set(x, "horizontalPageBreakRepeat", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setHorizontalPageBreakRepeatUndefined: Self = StObject.set(x, "horizontalPageBreakRepeat", js.undefined)
    
    @scala.inline
    def setHorizontalPageBreakUndefined: Self = StObject.set(x, "horizontalPageBreak", js.undefined)
    
    @scala.inline
    def setHtml(value: String | HTMLTableElement): Self = StObject.set(x, "html", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setHtmlUndefined: Self = StObject.set(x, "html", js.undefined)
    
    @scala.inline
    def setIncludeHiddenHtml(value: Boolean): Self = StObject.set(x, "includeHiddenHtml", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setIncludeHiddenHtmlUndefined: Self = StObject.set(x, "includeHiddenHtml", js.undefined)
    
    @scala.inline
    def setMargin(value: MarginPaddingInput): Self = StObject.set(x, "margin", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setMarginUndefined: Self = StObject.set(x, "margin", js.undefined)
    
    @scala.inline
    def setMarginVarargs(value: Double*): Self = StObject.set(x, "margin", js.Array(value :_*))
    
    @scala.inline
    def setPageBreak(value: PageBreakType): Self = StObject.set(x, "pageBreak", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setPageBreakUndefined: Self = StObject.set(x, "pageBreak", js.undefined)
    
    @scala.inline
    def setRowPageBreak(value: RowPageBreakType): Self = StObject.set(x, "rowPageBreak", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setRowPageBreakUndefined: Self = StObject.set(x, "rowPageBreak", js.undefined)
    
    @scala.inline
    def setShowFoot(value: ShowFootType): Self = StObject.set(x, "showFoot", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setShowFootUndefined: Self = StObject.set(x, "showFoot", js.undefined)
    
    @scala.inline
    def setShowHead(value: ShowHeadType): Self = StObject.set(x, "showHead", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setShowHeadUndefined: Self = StObject.set(x, "showHead", js.undefined)
    
    @scala.inline
    def setStartY(value: Double | `false`): Self = StObject.set(x, "startY", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setStartYUndefined: Self = StObject.set(x, "startY", js.undefined)
    
    @scala.inline
    def setStyles(value: PartialStyles): Self = StObject.set(x, "styles", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setStylesUndefined: Self = StObject.set(x, "styles", js.undefined)
    
    @scala.inline
    def setTableId(value: String | Double): Self = StObject.set(x, "tableId", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setTableIdUndefined: Self = StObject.set(x, "tableId", js.undefined)
    
    @scala.inline
    def setTableLineColor(value: Color): Self = StObject.set(x, "tableLineColor", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setTableLineColorUndefined: Self = StObject.set(x, "tableLineColor", js.undefined)
    
    @scala.inline
    def setTableLineWidth(value: Double): Self = StObject.set(x, "tableLineWidth", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setTableLineWidthUndefined: Self = StObject.set(x, "tableLineWidth", js.undefined)
    
    @scala.inline
    def setTableWidth(value: TableWidthType): Self = StObject.set(x, "tableWidth", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setTableWidthUndefined: Self = StObject.set(x, "tableWidth", js.undefined)
    
    @scala.inline
    def setTheme(value: ThemeType): Self = StObject.set(x, "theme", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setThemeNull: Self = StObject.set(x, "theme", null)
    
    @scala.inline
    def setThemeUndefined: Self = StObject.set(x, "theme", js.undefined)
    
    @scala.inline
    def setUseCss(value: Boolean): Self = StObject.set(x, "useCss", value.asInstanceOf[js.Any])
    
    @scala.inline
    def setUseCssUndefined: Self = StObject.set(x, "useCss", js.undefined)
    
    @scala.inline
    def setWillDrawCell(value: /* data */ CellHookData => Unit | Boolean): Self = StObject.set(x, "willDrawCell", js.Any.fromFunction1(value))
    
    @scala.inline
    def setWillDrawCellUndefined: Self = StObject.set(x, "willDrawCell", js.undefined)
  }
}
